export const getAccountKey = (accountNameOwner: String) => [
  "accounts",
  accountNameOwner,
];

export const getTotalsKey = (accountNameOwner: String) => [
  "totals",
  accountNameOwner,
];
